import React from 'react'

import { useMediaDevice } from '@bcraft-frontend-lib/core'

interface IDefineDeviceComponentProps {
  [key: string]: React.ReactElement
}

export const DefineDeviceComponent: React.FC<IDefineDeviceComponentProps> = ({ desktopComponent, mobileComponent }) => {
  const isMobileOfTablet = useMediaDevice({ query: 'maxLaptop' })
  return isMobileOfTablet ? mobileComponent : desktopComponent
}
